import React, { useEffect, useRef, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

const PaypalButton = ({ total, userData }) => {
  const BACKEND_URL = `${process.env.REACT_APP_API_URL}`; // Changez l'URL si nécessaire
  const [order, setOrder] = useState(null);
  const totalRef = useRef(total); // Référence pour capturer la dernière valeur de total
  const userDataRef = useRef(userData);
  // Mettez à jour la référence à chaque fois que total change
  useEffect(() => {
    totalRef.current = total;
    userDataRef.current = userData;
  }, [total, userData]);

  const isFormComplete = () => {
    // Vérifie si tous les champs requis dans userData sont remplis
    const allFieldsFilled = Object.values(userData).every(
      (value) => value !== "" && value !== null
    );
    // Vérifie si le montant est défini et valide
    return allFieldsFilled && totalRef.current !== null && totalRef.current > 0;
  };

  const createOrder = async () => {
    const response = await fetch(`${BACKEND_URL}/paypal/create-payment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: totalRef.current,
        currency: "EUR",
        returnUrl: "http://localhost:3000/paypal/return",
        cancelUrl: "http://localhost:3000/paypal/cancel",
      }),
    });
    const data = await response.json();
    return data.id; // Retourne l'ID de la commande créée
  };

  const onApprove = async (data, actions) => {
    const order = await actions.order.capture();
    await fetch(`${BACKEND_URL}/paypal/capture-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        orderId: order.id,
        transactionData: order.purchase_units[0].payments.captures[0],
        userData: userDataRef.current, // Données supplémentaires de l'utilisateur
      }),
    });
    alert("Paiement réussi");
  };

  return (
    <PayPalScriptProvider
      options={{
        "client-id":
          "AZqnrqglvAhRiegIqS-WHXMfIlHyuexYz5tijYACuJ0YUENt1EjVYz9We6IDhLhzRUR9ONTJUSk-9EgZ", // Utilisez le mode Sandbox pour les tests
        currency: "EUR",
      }}
    >
      <PayPalButtons
        createOrder={createOrder}
        onApprove={onApprove}
        disabled={!isFormComplete()}
      />
    </PayPalScriptProvider>
  );
};

export default PaypalButton;
